import React from 'react';
import PropTypes from 'prop-types';
// Components
import DownloadCTA from '../download-cta';
// Styles
import { useLayout } from '../layout/context';
import { Container } from '../styled/containers';
import { FileImage, Wrapper, FileDetails, StyledBanner } from './styles';

const DownloadBanner = ({
  headerText,
  removeMarginBottom,
  downloadCta,
  filePreview,
  backgroundColor,
  buttonType,
}) => {
  const { insideContainer } = useLayout();

  const buttonTypes = {
    Primary: 'primary',
    Secondary: 'secondary-outline',
  };

  return (
    <StyledBanner
      $removeMarginBottom={removeMarginBottom}
      $backgroundColor={backgroundColor}
    >
      <Container $padding={!insideContainer || !filePreview}>
        <Wrapper>
          {filePreview && (
            <FileImage
              $image={`${filePreview.file.url}`}
              data-testid="file-preview-image"
            />
          )}
          <FileDetails $paddingLeft={filePreview}>
            {headerText ? <p>{headerText}</p> : null}
            {downloadCta && (
              <DownloadCTA
                {...downloadCta}
                buttonType={buttonTypes[buttonType]}
              />
            )}
          </FileDetails>
        </Wrapper>
      </Container>
    </StyledBanner>
  );
};

DownloadBanner.propTypes = {
  headerText: PropTypes.string.isRequired,
  downloadCta: PropTypes.shape(DownloadCTA.propTypes),
  filePreview: PropTypes.shape({
    description: PropTypes.string.isRequired,
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
  removeMarginBottom: PropTypes.bool,
  backgroundColor: PropTypes.string,
  buttonType: PropTypes.string,
};

export default DownloadBanner;

export const DownloadBannerAssembly = ({ contentfulData }) => (
  <DownloadBanner
    headerText={contentfulData.headerText}
    downloadCta={
      contentfulData.downloadCta &&
      contentfulData.downloadCta.download &&
      contentfulData.downloadCta.download.file
        ? contentfulData.downloadCta
        : null
    }
    backgroundColor={contentfulData.backgroundColor}
    buttonType={contentfulData.buttonType}
    removeMarginBottom={contentfulData.removeMarginBottom}
    filePreview={
      contentfulData.downloadCta && contentfulData.downloadCta.filePreview
    }
  />
);

DownloadBannerAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
